<section>
  <div class="container d-flex align-items-center justify-content-center my-5">
    <div class="card card-fixed" style="z-index: 999">
      <div class="d-flex align-items-center justify-content-center">
        <img
          alt="logoBimbo"
          src="../../../../../assets/Icons/logo.svg"
          width="350px"
          class="m-0 p-0" />
      </div>
      <hr />
      <div class="card-body text-center">
        <h1 class="title-blue-h1-cap my-0">
          <b>{{ fullName }}</b>
        </h1>
        <h1 class="title-blue-h1-cap">¡Gracias por confirmar tu asistencia!</h1>
        <h2><b>Evento:</b> {{ nombrecurso }}</h2>
        <h3 *ngIf="!masterQrData?.qrMaestro">
          <b>D&iacute;a: </b>{{ numSession }}
        </h3>
        <h3 *ngIf="masterQrData?.totalPartesReales">
          <b>D&iacute;as totales: </b>{{ masterQrData?.totalPartesReales }}
        </h3>
        <h3 class="title-blue-bimbo-cap text-center">
          Esperamos que las enseñanzas del evento las puedas aplicar en tu día a
          día
        </h3>
      </div>
    </div>
  </div>
  <div class="wave wave1"></div>
  <div class="wave wave2"></div>
  <div class="wave wave3"></div>
</section>
